import {Space} from "antd";
import {FormWrapper} from "../../../../../components/form-wrapper";
import {CreateKycMultiFormStepHeader} from "../header";
import {CreateKycBasicDetailsStep} from "../basic-details";
import {useCreateKycContext} from "../../context/create-kyc";
import {CreateKycDocumentUploadStep} from "../document-upload";
import {useEffect} from "react";
import {FullPageLoader} from "../../../../../components/full-page-loader";
import {useGetKycStatusContext} from "../../../get-kyc-status/context/get-kyc-status";

export function CreateKycMultiStepForm() {
  const {
    state: {currentCreateKycStep},
  } = useCreateKycContext();
  const {
    state: {isLoadingKycStatus},
  } = useGetKycStatusContext();

  useEffect(() => {
    const container = document.querySelector("#main-section-container");
    container?.scrollTo({top: 0, behavior: "smooth"});
  }, [currentCreateKycStep]);
  // console.log({basicFormData, documentUploadFormData});
  return (
    <FormWrapper>
      <Space size={16} direction="vertical" style={{display: "flex"}}>
        <CreateKycMultiFormStepHeader />
        {isLoadingKycStatus ? (
          <FullPageLoader />
        ) : currentCreateKycStep === "basicForm" ? (
          <CreateKycBasicDetailsStep />
        ) : currentCreateKycStep === "documentUpload" ? (
          <CreateKycDocumentUploadStep />
        ) : null}
      </Space>
    </FormWrapper>
  );
}
